import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import ProjectActivityAreaChart from '../components/ProjectActivityAreaChart'
import DashboardSummaries from '../components/summaries/DashboardSummaries'
import CheckinTemplatePills from '../components/checkin/CheckinTemplatePills'
import { Checkin } from '../api/client'

const DashboardPage: React.FC = () => {
  const navigate = useNavigate()

  // A Dashboard tap does the same apply the Checkins page does, then hands the
  // result over: the new checkin's id rides along in the navigation state, and
  // Checkins gives that one row the landing entrance. There is nothing to show
  // for it here — the Dashboard has no timeline to drop it into.
  const handleApplied = useCallback((checkin: Checkin) => {
    navigate('/checkins', { state: { landedCheckinId: checkin.id } })
  }, [navigate])

  return (
    <div className="flex flex-col min-h-screen bg-blush-light">
      {/* Full-bleed activity landscape, flush under the nav. Below the legend
          band the gap is the summaries container's own p-4 on mobile, where
          that same 16px is the cards' side inset — anything more reads as a
          stray gap against them. From sm up the cards are inset 56-64px
          instead, and the wider 48px gap is what matches. */}
      <div className="sm:mb-8">
        <ProjectActivityAreaChart />
      </div>

      {/* The shared page container, reapplied below the full-bleed hero */}
      <div className="max-w-7xl mx-auto w-full px-0 sm:px-6 lg:px-8 pb-8">
        {/* The one-tap repeat checkins, below the activity legend and above
            the summaries. Display only: no label, no upsell, and nothing at
            all when the user has no templates. */}
        <CheckinTemplatePills mode="dashboard" onApplied={handleApplied} />

        {/* Summaries — create and view summaries for any project. */}
        {/* No panel of its own — the cards sit straight on the page tint. */}
        <div className="mb-8 sm:mx-4 p-4">
          <DashboardSummaries />
        </div>
      </div>
    </div>
  )
}

export default DashboardPage
